import React, { useEffect, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useLocation } from 'react-router-dom'
import '../../../Components/Form/Fields/roundedInput.scss'
import { cms, getTermsConditionPageId } from '../../../helper'
import { checkValidationForPayment } from '../../../Helper/paymentHelper'
import { useDispatch, useSelector } from 'react-redux'
import { clearNotification, setNotification } from '../../../Redux/Reducers/notificationHandling'
import { request } from '../../../Redux/Sagas/requests/api'
import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from '../../../Helper/cookieHelper'
import { readBookingSession } from '../../../Helper/publicPageHelper'
import PaymentConfirm from './paymentVerification'
import { primary_color } from '../../../Helper/uiHelper'
import { useHistory } from 'react-router-dom'
import TermsConditions from '../../Sections/termsconditions'
import useMediaQuery from '../../../CustomHook/useMediaQuery'
import Select from 'react-select'
import { select } from 'redux-saga/effects'
import { Button } from 'reactstrap'
import { usePublicPageContext } from '../../../Context/publicPageContext'
import DisableBackButton from '../../DisableBack/disableBack'

const checkExpiryValidation = (enteredExpiry) => {
  // Example: March 2025
  if (!enteredExpiry) return true
  // Get the current date
  const currentDate = new Date()

  // Extract month and year from entered expiry
  const enteredMonth = parseInt(enteredExpiry.slice(0, 2), 10) // Extracts 'MM' part and converts to integer
  const enteredYear = parseInt(enteredExpiry.slice(2), 10) // Extracts 'YY' part and converts to integer

  // Add 1 to the month because JavaScript months are zero-based (0-January, 1-February, ...)
  const adjustedEnteredDate = new Date(2000 + enteredYear, enteredMonth - 1, 1) // 2000 is added to the year for YY to YYYY conversion

  adjustedEnteredDate.setMonth(adjustedEnteredDate.getMonth() + 1)
  adjustedEnteredDate.setDate(0)
  // Check if entered expiry date is greater than or equal to current date
  if (adjustedEnteredDate > currentDate) {
    return true
  } else {
    return false
  }
  return true
}
const getPayload = (user, userAddress, cardDetails, uuid, no_payment, paymentActionCheck) => {
  if (!user?.email) {
    return {
      cardNumber: cardDetails?.cardNumber,
      cardholderName: cardDetails?.cardholderName,
      expiryDate: `${cardDetails?.month}${cardDetails?.year?.slice(2)}`,
      securityCode: cardDetails?.securityCode,
      description: 'shopping',
      customerFirstName: userAddress?.customerFirstName,
      customerLastName: userAddress?.customerLastName,
      address1: userAddress?.address1,
      address2: userAddress?.address1,
      city: userAddress?.city,
      // country: userAddress?.country,
      country: 'GB',
      state: 'Devon',
      // postalCode: parseInt(userAddress?.post_code),
      postalCode: userAddress?.post_code,
      customer_email: userAddress?.customer_email,
      booking_id: 2,
      currency_id: 1,
      return_type: 'json',
      //address_id:15
      uuid: uuid,
      no_payment,
      subscribe: !!paymentActionCheck?.includes('subscribe'),
      rebook: !!paymentActionCheck?.includes('rebook_checkbox'),
      //user_id:1
    }
  } else {
    return {
      cardNumber: cardDetails?.cardNumber,
      cardholderName: cardDetails?.cardholderName,
      expiryDate: `${cardDetails?.month}${cardDetails?.year?.slice(2)}`,
      securityCode: cardDetails?.securityCode,
      description: 'shopping',
      state: 'Devon',
      booking_id: 2,
      currency_id: 1,
      return_type: 'json',
      address_id: userAddress?.id,
      uuid: uuid,
      user_id: user?.id,
      no_payment,
      subscribe: !!paymentActionCheck?.includes('subscribe'),
      rebook: !!paymentActionCheck?.includes('rebook_checkbox'),
    }
  }
}

const DUMMY_PAYLOAD = {
  cardNumber: '4929000000006',
  cardholderName: 'CHALLENGE',
  expiryDate: '1223',
  securityCode: '123',
  description: 'shopping',
  customerFirstName: 'CHALLENGE',
  customerLastName: 'sheikh',
  address1: 'Russell St',
  address2: 'Russell St',
  city: 'Tavistock',
  country: 'GB',
  state: 'Devon',
  postalCode: 412,
  customer_email: 'nadim.sheikh.07@gmail.com',
  booking_id: 2,
  currency_id: 1,
  return_type: 'json',
  //address_id:15
  uuid: 'c385890b-cb32-4b34-b270-aa77b48b4874',
  //user_id:1
  amount: 100,
}

const dummy_checkbox_data = [
  { label: 'I would like to receive future communications from Secure Lockers.', value: 'subscribe' },
  { label: 'I would like to book again next year.', value: 'rebook_checkbox' },
  // { label: 'Accept Terms & Conditions.', value: 3 },
]

const getCheckbox = (data) => {
  if (!data?.rebook) {
    return [{ label: 'I would like to receive future communications from Secure Lockers.', value: 'subscribe' }]
  } else {
    return dummy_checkbox_data
  }
}

const PaymentMethod = ({
  form,
  data,
  userAddress,
  parentData,
  pageData,
  setActivePage,
  setParentData,
  onGoBackToHomePage,
  userAddressValidation,
  setUserAddressValidation,
  couponCode,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { state, updateState } = usePublicPageContext()
  const searchParams = new URLSearchParams(location.search)
  const payment_id = searchParams.get('payment_id')
  const isAdminFlow = searchParams.get('is_admin')
  const isFromLink = searchParams.get('link_id')
  const isEditing = searchParams.get('edit_booking')
  const paymentId = searchParams.get('payment_id')
  const domainId = searchParams.get('parent_id')
  const isLink = searchParams.get('link_id')

  const [isDoingPayment, setIsDoingPayment] = useState(false)

  const isDesktop = useMediaQuery('(min-width:768px)')
  const notificationMsg = useSelector((state) => state.NotificationHandling.message)

  const [showTerms, setShowTerms] = useState(false)
  let storage_timer = getLocalStorageItem('timer') && JSON.parse(getLocalStorageItem('timer'))
  let current_storage_timer = readBookingSession(parentData?.id)

  const publicUser = useSelector((state) => state.User.publicUser)
  const [cardDetails, setCardDetails] = useState({
    cardNumber: null,
    cardholderName: null,
    month: null,
    year: null,
    securityCode: null,
  })

  const [years, setYears] = useState([])
  const [months, setMonths] = useState([])
  const [paymentConfirmData, setPaymentConfirmData] = useState()
  const [paymentActionCheck, setPaymentActionCheck] = useState(['subscribe'])
  const [showValidation, setShowValidation] = useState(false)
  const [cardNumber, setCardNumber] = useState('')
  const [paymentDetails, setPaymentDetails] = useState()
  const [rebookType, setRebookType] = useState()
  const [termsConditionAccepted, setTermsConditionAccepted] = useState(true)
  useEffect(() => {
    if (!domainId) return
    request('get-rebook-by-domain-id', 'POST', { domain_id: domainId }).then((res) => {
      if (res?.data) {
        setRebookType(res?.data)
        const action = ['subscribe']
        if (res?.data?.rebook) {
          action.push('rebook_checkbox')
        }
        setPaymentActionCheck(action)
      }
    })
  }, [domainId])

  useEffect(() => {
    const years_data = []
    const current_year = new Date().getFullYear()
    for (let year = current_year; year <= 2070; year++) {
      years_data.push(year.toString())
    }
    setYears(years_data)
    const months_data = []
    for (let i = 1; i <= 12; i++) {
      if (i < 10) {
        months_data?.push({
          label: `0${i}`,
          value: `0${i}`,
        })
      } else {
        months_data?.push({
          label: i,
          value: i,
        })
      }
    }
    setMonths(months_data)
  }, [])

  useEffect(() => {
    // if (!current_storage_timer?.session_uuid || !paymentId) return
    if (current_storage_timer?.session_uuid || paymentId) {
      request('payments/get', 'POST', {
        uuid: current_storage_timer?.session_uuid,
        coupon_code: couponCode,
        payment_id: paymentId && parseInt(paymentId),
        is_link: !!isLink,
      }).then((res) => {
        setPaymentDetails(res?.data)
        // Allow £0 after voucher (100% discount). Only bounce when there was never a payable amount.
        const preDiscountAmount = Number(res?.data?.amount || 0)
        const payableAmount = Number(res?.data?.total_amount || 0)
        if (!isEditing && !isLink && payableAmount <= 0 && preDiscountAmount <= 0) {
          history.push('/')
          removeLocalStorageItem('timer')
          dispatch(setNotification({ type: 'error', message: 'There is no pending payment!' }))
        }
      })
    } else {
      history.push('/')
      dispatch(setNotification({ type: 'error', message: 'Session expired!' }))
    }
  }, [couponCode, parentData?.id])

  const formChange = (e) => {
    dispatch(clearNotification())
    if (showValidation) setShowValidation(false)
    let { name, value } = e.target
    if (name === 'securityCode' || name === 'cardNumber') {
      value = value.replace(/\D/g, '')
    }

    setCardDetails((prev) => {
      return { ...prev, [name]: value }
    })
  }

  useEffect(() => {
    dispatch(clearNotification())
    updateState({ noPendingPayment: false })
  }, [])
  const cardInputRef = useRef(null)
  const cardNumberChange = (e) => {
    dispatch(clearNotification())

    const input = e.target
    const rawValue = input.value
    const cursorPosition = input.selectionStart

    // Remove all non-digits
    let digits = rawValue.replace(/\D/g, '')

    // Limit to 16 digits
    if (digits.length > 16) digits = digits.slice(0, 16)

    // Format with space every 4 digits
    const formatted = digits.replace(/(.{4})/g, '$1 ').trim()

    // Figure out new cursor position
    let nextCursor = cursorPosition

    // Count spaces before and after formatting
    const rawLeft = rawValue.slice(0, cursorPosition)
    const rawDigitsLeft = rawLeft.replace(/\D/g, '')
    nextCursor = rawDigitsLeft.length + Math.floor(rawDigitsLeft.length / 4)

    setCardNumber(formatted)
    setCardDetails((prev) => ({
      ...prev,
      cardNumber: digits,
    }))

    // Delay setting cursor until after DOM updates
    setTimeout(() => {
      cardInputRef.current?.setSelectionRange(nextCursor, nextCursor)
    }, 0)
  }

  const selectFormChange = (e, name) => {
    dispatch(clearNotification())
    if (showValidation) setShowValidation(false)
    let { label, value } = e

    setCardDetails((prev) => {
      return { ...prev, [name]: value }
    })
  }
  const expireSession = () => {
    let storage_timer = getLocalStorageItem('timer') && JSON.parse(getLocalStorageItem('timer'))
    const finishedSessionId = current_storage_timer?.session_id
    if (storage_timer && finishedSessionId) {
      Object.keys(storage_timer).forEach((key) => {
        if (storage_timer[key]?.session_id === finishedSessionId) {
          delete storage_timer[key]
        }
      })
    } else if (storage_timer) {
      delete storage_timer?.[parentData?.id]
    }
    let storage_data = ''
    if (storage_timer) {
      storage_data = JSON.stringify(storage_timer)
    }
    setLocalStorageItem('timer', storage_data)
  }

  const handlePaymentClick = (e, noValidation) => {
    e.preventDefault()
    setShowValidation(true)
    updateState({ noPendingPayment: true })
    const validation = checkValidationForPayment(userAddress, cardDetails, publicUser?.email ? true : false)
    const skipCardValidation = noValidation === true || noValidation === 'zero_amount'
    const useLegacyNoPayment = noValidation === true
    // Free voucher still needs billing/address; only skip card fields.
    if (!useLegacyNoPayment && userAddressValidation !== 'Success') {
      dispatch(setNotification({ type: 'error', message: 'Please fill all the required fields.' }))
      return setUserAddressValidation(true)
    }

    if (!checkExpiryValidation(`${cardDetails?.month}${cardDetails?.year?.slice(2)}`) && !skipCardValidation) {
      return
    }
    // if (validation?.error) {
    //   dispatch(setNotification({ type: 'error', message: validation?.message }))
    //   return
    // }

    let payload = getPayload(publicUser, userAddress, cardDetails, current_storage_timer?.session_uuid, useLegacyNoPayment, paymentActionCheck)

    // Tell the API to skip card validation; amount is re-checked server-side before free checkout.
    if (noValidation === 'zero_amount') {
      const {
        cardNumber,
        cardholderName,
        expiryDate,
        securityCode,
        ...rest
      } = payload
      payload = { ...rest, zero_amount_checkout: true }
    }

    if (couponCode) {
      payload = { ...payload, coupon_code: couponCode }
    }
    if (payment_id) {
      payload = {
        ...payload,
        payment_id: parseInt(payment_id),
      }
    }
    if (isFromLink) {
      payload = {
        ...payload,
        payment_link: true,
      }
    }
    setIsDoingPayment(true)
    if (!isFromLink && !payment_id && !payload.uuid) {
      dispatch(setNotification({ type: 'error', message: 'Session expired' }))
      setIsDoingPayment(false)
      history.push('/')
      return
    }
    request('payments/make', 'POST', payload)
      .then((res) => {
        if (res?.data?.acsUrl) {
          expireSession()
          setPaymentConfirmData(res?.data)
          // dispatch(setNotification({ type: 'error', message: res?.data?.status_text }))
        } else if (res?.data?.status === '0000') {
          expireSession()

          window.history.pushState({ preventBack: true }, '', window.location.pathname + window.location.search)
          let url = `/payment-success-list?uuid=${res?.data?.uuid}&payment_uuid=${res?.data?.payment_uuid}`
          if (isEditing) {
            url += '&edit_booking=true&isShowOnlyContent=true'
          }
          window.location.replace(url)
        } else {
          dispatch(setNotification({ type: 'error', message: res?.data?.message || 'Unable to process payment.' }))
        }
      })
      .catch((err) => {
        const apiMessage = err?.response?.data?.message
        dispatch(setNotification({ type: 'error', message: apiMessage || 'Unable to process payment. Please try again.' }))
      })
      .finally(() => {
        setIsDoingPayment(false)
        setTimeout(() => {
          dispatch(clearNotification())
        }, 3000)
      })
  }

  const onChangeAction = (e) => {
    dispatch(clearNotification())
    let newData = [...paymentActionCheck]

    if (e.target.checked) {
      newData?.push(e.target.value)
    } else {
      let index = newData.indexOf(e.target.value)
      newData.splice(index, 1)
    }
    setPaymentActionCheck(newData)
  }

  const checkboxData = getCheckbox(rebookType)

  if (isAdminFlow) return
  if (paymentDetails?.in_progress) {
    return (
      <div className='col-md-12 mt-3 ml-auto mr-auto'>
        <div class='alert alert-warning' role='alert'>
          Payment is in progress. Please wait till payment gets completed!
        </div>
      </div>
    )
  }
  // Free checkout: pre-discount free OR voucher took payable total to £0 (e.g. 100% discount)
  const payableTotal = Number(paymentDetails?.total_amount ?? paymentDetails?.amount ?? 0)
  const chargeTotal = Number(paymentDetails?.charge || 0)
  if (payableTotal <= 0 && chargeTotal <= 0 && paymentDetails) {
    return (
      <div className='d-flex mt-4'>
        {!isEditing && (
          <button
            className='btn text-danger '
            style={{
              borderRadius: '30px',
              background: 'transparent',
              border: '1px solid red',
              padding: isDesktop ? '0.4rem 5.5rem' : '0.6rem 3rem',
            }}
            onClick={() => {
              onGoBackToHomePage()
            }}>
            Cancel
          </button>
        )}

        <button
          className='btn ml-3 d-flex justify-content-center py-3'
          style={{ color: 'white', borderRadius: '30px', background: primary_color, padding: isDesktop ? '0.4rem 4.5rem' : '0.6rem 2rem' }}
          onClick={(e) => {
            e.stopPropagation()
            // Prefer the zero-amount payment path (marks voucher used + confirmation email).
            // Fall back to legacy no_payment only when we already have a payment_id.
            handlePaymentClick(e, payment_id ? true : 'zero_amount')
          }}
          type='button'
          disabled={isDoingPayment}>
          <span>{isDoingPayment ? 'pending...' : 'Continue'}</span>
          <i className='fa-sharp fa-solid fa-arrow-right ml-2' style={{ marginTop: 4 }}></i>
        </button>
      </div>
    )
  }
  return (
    <div className='col-md-12 mt-3 ml-auto mr-auto'>
      <div className='border-bottom pb-4 ' style={{ marginLeft: 'auto' }}>
        <form
          className='needs-validation'
          noValidate
          onSubmit={handlePaymentClick}
          style={{ marginBlock: '2rem' }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
            }
          }}>
          <div className='font-weight-bold mb-3 body1' style={{ color: primary_color }}>
            {/* {cms(data.heading)} */}
            {'Payment Method'}
          </div>
          <>
            <div className='mb-3'>
              <div className='mb-2 font-weight-bold subtitle1'>Card Details</div>
              <div className='d-flex flex-column flex-md-row mb-2' style={{ gap: '0.5rem' }}>
                <div className='d-inline w-100'>
                  <input
                    onChange={formChange}
                    className={`form-control subtitle1 rounded-pill rounded-input rounded-pill-no-icon ${
                      showValidation && !cardDetails.cardholderName ? 'error-input' : ''
                    }`}
                    placeholder='Name on card'
                    value={cardDetails.cardholderName}
                    name='cardholderName'
                    type='text'
                  />
                  {showValidation && !cardDetails.cardholderName && <div className='text-danger subtitle1'>Please enter card holder name</div>}
                </div>
                <div className='d-inline w-100'>
                  <input
                    onChange={formChange}
                    className={`form-control subtitle1 rounded-pill rounded-input rounded-pill-no-icon ${
                      showValidation && !cardDetails.securityCode ? 'error-input' : ''
                    }`}
                    placeholder='CVV'
                    value={cardDetails.securityCode}
                    maxLength={3}
                    type='text'
                    name='securityCode'
                  />
                  {showValidation && !cardDetails.securityCode && <div className='text-danger subtitle1'>Please enter cvv</div>}
                </div>
              </div>
              <div className='w-100 mt-3'>
                <input
                  // onChange={formChange}
                  onChange={cardNumberChange}
                  className={`form-control subtitle1 rounded-pill rounded-input rounded-pill-no-icon ${
                    showValidation && !cardDetails.cardNumber ? 'error-input' : ''
                  }`}
                  placeholder='Card Number'
                  // type='password'
                  // value={cardDetails.cardNumber}
                  value={cardNumber}
                  // maxLength={16}
                  name='cardNumber'
                  ref={cardInputRef}
                />
                {showValidation && !cardDetails.cardNumber ? <div className='text-danger subtitle1'>Please enter card number</div> : <></>}
              </div>
            </div>
            <div className='mb-5'>
              <div className='mb-2 font-weight-bold subtitle1'>Expiry date</div>
              <div className='d-flex flex-column flex-md-row mb-2' style={{ gap: '0.5rem' }}>
                <div className='d-inline w-100'>
                  <Select
                    classNamePrefix='rounded-select'
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: '50px',
                        borderColor: showValidation && !cardDetails.month ? 'red' : baseStyles.borderColor,
                        // padding: '0.3rem 1rem',
                      }),
                      placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: showValidation && !cardDetails.month ? 'red' : 'rgba(0, 0, 0, 0.2)',
                      }),
                    }}
                    placeholder='Month'
                    onChange={(e) => selectFormChange(e, 'month')}
                    options={months}
                    className='subtitle1'
                    inputProps={{ autoComplete: 'off' }}
                  />
                  {showValidation && !cardDetails.month ? <div className='text-danger subtitle1'>Please enter expiry month</div> : <></>}
                </div>

                <div className='d-inline w-100'>
                  <Select
                    classNamePrefix='rounded-select'
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: '50px',
                        borderColor: showValidation && !cardDetails.year ? 'red' : baseStyles.borderColor,
                        // padding: '0.3rem 1rem',
                      }),
                      placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: showValidation && !cardDetails.year ? 'red' : 'rgba(0, 0, 0, 0.2)',
                      }),
                    }}
                    placeholder='Year'
                    onChange={(e) => selectFormChange(e, 'year')}
                    options={years.map((e) => {
                      return { label: e, value: e }
                    })}
                    className='subtitle1'
                    inputProps={{ autoComplete: 'off' }}
                  />
                  {showValidation && !cardDetails.year ? <div className='text-danger subtitle1'>Please enter expiry year</div> : <></>}
                </div>
              </div>
              {showValidation && !checkExpiryValidation(`${cardDetails?.month}${cardDetails?.year?.slice(2)}`) && (
                <div className='text-danger mt-2 subtitle1'>Expiry date is not valid!</div>
              )}
            </div>
          </>

          <div className='mb-5 mt-4'>
            {checkboxData.map((element, index) => (
              <div key={index} className={isDesktop ? '' : 'd-flex align-items-start '}>
                <input
                  // required
                  type='checkbox'
                  style={{ transform: 'scale(1.3)', marginTop: isDesktop ? '0' : '0.35rem' }}
                  value={element?.value}
                  onChange={(e) => onChangeAction(e)}
                  checked={paymentActionCheck?.includes(element?.value)}
                />
                <label style={{ textTransform: 'none', fontWeight: '400' }} className='ml-3 body2'>
                  {element?.label}
                </label>
              </div>
            ))}
            <div>
              <input
                required
                type='checkbox'
                checked={termsConditionAccepted}
                style={{ transform: 'scale(1.3)' }}
                value={3}
                onChange={(e) => {
                  onChangeAction(e)
                  setTermsConditionAccepted(e.target.checked)
                }}
              />
              <label style={{ textTransform: 'none', fontWeight: '400' }} className='ml-3 body2'>
                Accept{' '}
                <span
                  style={{ color: primary_color, cursor: 'pointer', fontWeight: '700' }}
                  onClick={() => {
                    setShowTerms(!showTerms)
                    // window.open('/terms-and-condition-list', '_blank')
                  }}>
                  Terms & Conditions.
                </span>
              </label>
            </div>
            {showTerms && (
              <div
                style={{
                  overflow: 'hidden',
                  height: showTerms ? 'fit-content' : '0rem',
                  transition: 'height 1s ease',
                }}>
                <TermsConditions handleClose={() => setShowTerms(false)} page_uuid={getTermsConditionPageId()} />
              </div>
            )}
          </div>

          <div className='d-flex mt-4 flex-wrap'>
            {!isEditing && (
              <button
                className='btn btn-outline-danger rounded-pill font-weight-bold mt-2 mr-2  subtitle1'
                style={{
                  paddingInline: '5.3rem',
                  display: 'flex',
                  gap: '0.5rem',
                  alignItems: 'center',
                  // padding: isDesktop ? '0.7rem 5.5rem' : '0.6rem 3rem',
                }}
                // onClick={handlePaymentClick}
                type='submit'
                onClick={(e) => {
                  onGoBackToHomePage()
                }}>
                Cancel
              </button>
            )}

            <button
              className='btn btn-primary rounded-pill font-weight-bold mt-2  subtitle1'
              style={{ color: 'white', borderRadius: '30px', background: primary_color, padding: '0.4rem 4.5rem' }}
              // onClick={handlePaymentClick}
              type='submit'
              disabled={!termsConditionAccepted || isDoingPayment || (!userAddress?.id && !userAddress?.address1)}>
              <span>{isDoingPayment ? 'pending...' : 'Pay now'}</span>
              <i class='fa-sharp fa-solid fa-arrow-right ml-2' style={{ marginTop: 4 }}></i>
            </button>
          </div>
        </form>
      </div>
      {state?.noPendingPayment && <DisableBackButton redirectUrl={window.location.origin} reload />}
      {paymentConfirmData && <PaymentConfirm data={paymentConfirmData} />}
    </div>
  )
}

export default PaymentMethod
